export const adtMenuDef = [
    {
        name: 'menu.ip',
        icon: 'fa fa-user-md',
        data: {
            nav_url: "encounter_ipAdmission_m"
        },

        children: [
            {
                name: 'menu.ip_admission',
                resource: 'encounter_format',
                icon: 'fa fa-plus-square',
                url: 'encounter_format',
                auto_crud: true,
                breadcrumb: 'Admission',
                check_permission: false
            },
            {
                name: 'menu.inter_facility_referral_admission',
                resource: 'inter_facility_referral_admission',
                icon: 'fa fa-plus-square',
                url: 'inter_facility_referral_admission',
                auto_crud: true,
                breadcrumb: 'Admission',
                check_permission: false
            },
            {
                "name": "menu.anc_registration_records",
                "resource": "anc_registration_record",
                "icon": "fa fa-user-md",
                "url": "anc_registration_record",
                "check_permission": true,
                "auto_crud": true,
                "breadcrumb": "ANC Registration Record"
            },
            {
                name: 'menu.eligibility_form',
                resource: 'eligibility_form',
                icon: 'fa fa-plus-square',
                url: 'eligibility_form',
                check_permission: false,
                auto_crud: true,
                showMenu: true
            },
            {
                "name": "menu.fit_unfit_status",
                "resource": "fit_unfit_status",
                "icon": "fa fa-user-md",
                "url": "fit_unfit_status",
                "check_permission": true,
                "auto_crud": true,
                "breadcrumb": "Fit/Unfit Status"
            },
            {
                name: 'menu.ip_admission',
                resource: 'ip_bed_format',
                icon: 'fa fa-plus-square',
                url: 'ip_bed_format',
                auto_crud: true,
                breadcrumb: 'Admission',
                check_permission: false
            },
            {
                name: 'menu.ip_admission',
                resource: 'encounter_ipAdmission',
                icon: 'fa fa-plus-square',
                url: 'encounter_ipAdmission',
                auto_crud: true,
                breadcrumb: 'Admission',
                showMenu: false
            },
            {
                name: 'menu.ip_admission',
                resource: 'encounter_preAdmission',
                icon: 'fa fa-plus-square',
                url: 'encounter_preAdmission',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.counselling_draft',
                resource: "counselling_draft",
                icon: 'fa fa-h-square',
                url: 'counselling_draft',
                check_permission: false,
                auto_crud: true,
                showMenu: true
            },
            {
                name: 'menu.ip_admission',
                resource: 'encounter_DcPreAdmission',
                icon: 'fa fa-plus-square',
                url: 'encounter_DcPreAdmission',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.authorization_form',
                resource: 'op_authorization',
                icon: 'fa fa-plus-square',
                url: 'op_authorization',
                check_permission: false,
                auto_crud: true,
                showMenu: true
            },
            {
                name: 'menu.authorization_form',
                resource: 'admission_auth_request',
                icon: 'fa fa-plus-square',
                url: 'admission_auth_request',
                check_permission: false,
                auto_crud: true,
                showMenu: true
            },
            {
                name: 'menu.transfer_request',
                resource: 'ip_admission_transfer_format',
                icon: 'fa fa-h-square',
                url: 'ip_admission_transfer_format',
                breadcrumb: 'Transfer Request',
                auto_crud: true
            },
            {
                name: 'menu.transfer_request',
                resource: 'encounter_transfer',
                icon: 'fa fa-h-square',
                url: 'encounter_transfer',
                breadcrumb: 'Transfer Request',
                auto_crud: true
            },
            {
                name: 'menu.bed_to_housekeeping',
                resource: 'bed_to_housekeeping',
                icon: 'fa fa-h-square',
                url: 'bed_to_housekeeping',
                breadcrumb: 'Bed To Housekeeping',
                auto_crud: true
            },
            {
                name: 'menu.extra_bed_assignment',
                resource: 'encounter_extraBedAssignment',
                icon: 'fa fa-h-square',
                url: 'encounter_extraBedAssignment',
                breadcrumb: 'Extra Bed Assigned',
                auto_crud: true
            },
            {
                name: 'menu.encounter_retain_bed_details',
                resource: 'encounter_retain_bed_details',
                icon: 'fa fa-h-square',
                url: 'encounter_retain_bed_details',
                breadcrumb: 'Retain Bed',
                auto_crud: true
            },
            {
                name: 'menu.bed_assignment',
                resource: 'encounter_extra_bed_format',
                icon: 'fa fa-h-square',
                url: 'encounter_extra_bed_format',
                breadcrumb: 'Bed Assignment',
                auto_crud: true
            },
            {
                name: 'menu.cancel_admission',
                resource: 'encounter_cancelledIpAdmission',
                icon: 'fa fa-h-square',
                url: 'encounter_cancelledIpAdmission',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'er_transfer_history',
                resource: 'er_transfer_history',
                icon: 'fa fa-h-square',
                url: 'er_transfer_history',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'er_bedTransfer_history',
                resource: 'er_bedTransfer_history',
                icon: 'fa fa-h-square',
                url: 'er_bedTransfer_history',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'encounter_dc_transfer',
                resource: 'dc_admission_transfer_format',
                icon: 'fa fa-h-square',
                url: 'dc_admission_transfer_format',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'encounter_dc_transfer',
                resource: 'encounter_dc_transfer',
                icon: 'fa fa-h-square',
                url: 'encounter_dc_transfer',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.counselling_post_follow_up',
                resource: 'counselling_final_post_follow_up',
                icon: 'fa fa-h-square',
                url: 'counselling_final_post_follow_up',
                auto_crud: true,
                showMenu: false
            },
              {
                name: 'menu.followUp',
                resource: 'process_followUp',
                icon: 'fa fa-h-square',
                url: 'process_followUp',
                auto_crud: true,
                showMenu: false
            },
           {
                "name": "menu.add_followUp",
                "resource": "add_followUp",
                "icon": "fa fa-file-text-o",
                "url": "add_followUp",
                "auto_crud": true,
                "permission_required": false,
                "breadcrumb": "ADD Follow Up",
                "check_permission": false
            },
             {
                "name": "menu.addCareplan_followUp",
                "resource": "addCareplan_followUp",
                "icon": "fa fa-file-text-o",
                "url": "addCareplan_followUp",
                "auto_crud": true,
                "permission_required": false,
                "breadcrumb": "ADD Care Plan Follow Up",
                "check_permission": false
            },
            {
                name: 'menu.cancel_counselling',
                resource: 'counselling_detail_cancel',
                icon: 'fa fa-h-square',
                url: 'counselling_detail_cancel',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.confirm_counselling',
                resource: 'counselling_confirm',
                icon: 'fa fa-h-square',
                url: 'counselling_confirm',
                auto_crud: true,
                showMenu: false
            },
            {
                "name": "menu.confirm_counselling_followup",
                "resource": "confirm_counselling_followup",
                "icon": "fa fa-tag",
                "url": "confirm_counselling_followup",
                "auto_crud": true,
                "breadcrumb": "Confirm Counselling Follow Up",
                "check_permission": false,
                "showMenu": true
            },
            {
                name: 'menu.cancelled_transfer_history',
                resource: 'cancelled_transfer_history',
                icon: 'fa fa-h-square',
                url: 'cancelled_transfer_history',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.cancelled_doctor_transfer_history',
                resource: 'cancelled_doctor_transfer_history',
                icon: 'fa fa-h-square',
                url: 'cancelled_doctor_transfer_history',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.doctor_transfer_history',
                resource: 'doctor_transfer_history',
                icon: 'fa fa-h-square',
                url: 'doctor_transfer_history',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.bed_transfer_history',
                resource: 'bed_transfer_history',
                icon: 'fa fa-h-square',
                url: 'bed_transfer_history',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.bed_vacant',
                resource: 'bed_vacant',
                icon: 'fa fa-plus-square',
                url: 'bed_vacant',
                auto_crud: true,
                breadcrumb: 'bed-vacant',
                showMenu: false
            },
            {
                name: 'menu.nursing_clearance',
                resource: 'nursing_clearance',
                icon: 'fa fa-plus-square',
                url: 'nursing_clearance',
                auto_crud: true,
                breadcrumb: 'nursing_clearance',
                showMenu: false
            },
            {
                name: 'menu.fb_clearance',
                resource: 'fb_clearance',
                icon: 'fa fa-plus-square',
                url: 'fb_clearance',
                auto_crud: true,
                breadcrumb: 'fb_clearance',
                showMenu: false
            },
            {
                name: 'menu.ot_clearance',
                resource: 'ot_clearance',
                icon: 'fa fa-plus-square',
                url: 'ot_clearance',
                auto_crud: true,
                breadcrumb: 'ot_clearance',
                showMenu: false
            },
            {
                name: 'menu.pharmacy_clearance',
                resource: 'pharmacy_clearance',
                icon: 'fa fa-plus-square',
                url: 'pharmacy_clearance',
                auto_crud: true,
                breadcrumb: 'pharmacy_clearance',
                showMenu: false
            },
            {
                name: 'menu.billReady',
                resource: 'billReady',
                icon: 'fa fa-plus-square',
                url: 'billReady',
                auto_crud: true,
                breadcrumb: 'billReady',
                showMenu: false
            },
            {
                name: 'menu.bloodbank_clearance',
                resource: 'bloodbank_clearance',
                icon: 'fa fa-plus-square',
                url: 'bloodbank_clearance',
                auto_crud: true,
                breadcrumb: 'bloodbank_clearance',
                showMenu: false
            },
            {
                name: 'menu.cathlab_clearance',
                resource: 'cathlab_clearance',
                icon: 'fa fa-plus-square',
                url: 'cathlab_clearance',
                auto_crud: true,
                breadcrumb: 'cathlab_clearance',
                showMenu: false
            },
            {
                name: 'menu.tpa_clearance',
                resource: 'tpa_clearance',
                icon: 'fa fa-plus-square',
                url: 'tpa_clearance',
                auto_crud: true,
                breadcrumb: 'bed-vacant',
                showMenu: false
            },
            {
                name: 'menu.discharge',
                resource: 'discharge',
                icon: 'fa fa-plus-square',
                url: 'discharge',
                auto_crud: true,
                breadcrumb: 'discharge',
                showMenu: false
            },
            {
                name: 'menu.discharge_intimation_unacknowledge',
                resource: 'dischargeIntimation',
                icon: 'fa fa-plus-square',
                url: 'dischargeIntimation',
                auto_crud: true,
                breadcrumb: 'discharge-intimation',
                showMenu: false
            },
            {
                name: 'menu.ot_clearance',
                resource: 'ot_clearance',
                icon: 'fa fa-plus-square',
                url: 'ot_clearance',
                auto_crud: true,
                breadcrumb: 'ot-clearance',
                showMenu: false
            },
            {
                name: 'menu.security_clearance',
                resource: 'security_clearance',
                icon: 'fa fa-plus-square',
                url: 'security_clearance',
                auto_crud: true,
                breadcrumb: 'security-clearance',
                showMenu: false
            },
            {
                name: 'menu.housekeeping_clearance',
                resource: 'housekeeping_clearance',
                icon: 'fa fa-plus-square',
                url: 'housekeeping_clearance',
                auto_crud: true,
                breadcrumb: 'housekeeping-clearance',
                showMenu: false
            },
            {
                name: 'menu.transfer_history',
                resource: 'transfer_history',
                icon: 'fa fa-plus-square',
                url: 'transfer_history',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.hospital_transfer_history',
                resource: 'hospital_transfer_history',
                icon: 'fa fa-plus-square',
                url: 'hospital_transfer_history',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.initiate_discharge',
                resource: 'encounter_initiateDischarge',
                icon: 'fa fa-h-square',
                url: 'encounter_initiateDischarge',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.discharge',
                resource: 'encounter_discharged',
                icon: 'fa fa-h-square',
                url: 'encounter_discharged',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.admission_request',
                resource: 'encounter_admissionRequest',
                icon: 'fa fa-h-square',
                url: 'encounter_admissionRequest',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.admission_request',
                resource: 'encounter_dcAdmissionRequest',
                icon: 'fa fa-h-square',
                url: 'encounter_dcAdmissionRequest',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.extra_bed_assignment',
                resource: 'encounter_extraBedAssignment',
                icon: 'fa fa-h-square',
                url: 'encounter_extraBedAssignment',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.auto_admission',
                resource: 'auto_admission',
                icon: 'fa fa-plus-square',
                url: 'auto_admission',
                check_permission: false,
                auto_crud: true,
                showMenu: true
            },
            {
                name: 'menu.transfer_history_detail_tab',
                resource: 'transfer_history_detail_tab',
                icon: 'fa fa-plus-square',
                url: 'transfer_history_detail_tab',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.er_transfer_history_detail_tab',
                resource: 'er_transfer_history_detail_tab',
                icon: 'fa fa-plus-square',
                url: 'er_transfer_history_detail_tab',
                auto_crud: true,
                showMenu: false
            }

        ]
    },
    {
        name: 'menu.er',
        icon: 'fa fa-user-md',
        data: {
            nav_url: "encounter_erAdmission_m"
        },

        children: [
            {
                name: 'menu.er_admission',
                resource: 'emergency_format',
                icon: 'fa fa-plus-square',
                url: 'emergency_format',
                auto_crud: true,
                breadcrumb: 'Admission',
                check_permission: false
            },
            {
                name: 'menu.er_admission',
                resource: 'bed_format',
                icon: 'fa fa-plus-square',
                url: 'bed_format',
                auto_crud: true,
                breadcrumb: 'Admission',
                check_permission: false
            },
            {
                name: 'menu.er_admission',
                resource: 'encounter_erAdmission',
                icon: 'fa fa-plus-square',
                url: 'encounter_erAdmission',
                auto_crud: true,
                breadcrumb: 'ER Admission',
                showMenu: false
            },
            {
                name: 'menu.er_admission',
                resource: 'encounter_erDischarged',
                icon: 'fa fa-plus-square',
                url: 'encounter_erDischarged',
                auto_crud: true,
                breadcrumb: 'ER Discharge',
                showMenu: false
            },
            {
                name: 'menu.er_bed_transfer',
                resource: 'er_admission_transfer_format',
                icon: 'fa fa-h-square',
                url: 'er_admission_transfer_format',
                breadcrumb: 'ER Transfer',
                auto_crud: true,
                showMenu: true
            },
            {
                name: 'menu.er_bed_transfer',
                resource: 'encounter_bedTransfer',
                icon: 'fa fa-h-square',
                url: 'encounter_bedTransfer',
                breadcrumb: 'ER Transfer',
                auto_crud: true,
                showMenu: true
            },
            {
                name: 'encounter_erInitiateDischarge',
                resource: 'encounter_erInitiateDischarge',
                icon: 'fa fa-h-square',
                url: 'encounter_erInitiateDischarge',
                breadcrumb: 'ER Initiate-Discharge',
                auto_crud: true,
                showMenu: false
            }
        ]
    },


    {
        name: 'menu.dc',
        icon: 'fa fa-user-md',
        data: {
            nav_url: "encounter_dcAdmission_m"
        },

        children: [
            {
                name: 'menu.dc_admission',
                resource: 'daycare_format',
                icon: 'fa fa-plus-square',
                url: 'daycare_format',
                auto_crud: true,
                check_permission: false
            },
            {
                name: 'menu.dc_admission',
                resource: 'dc_bed_format',
                icon: 'fa fa-plus-square',
                url: 'dc_bed_format',
                auto_crud: true,
                breadcrumb: 'Admission',
                check_permission: false
            },
            {
                name: 'menu.dc_admission',
                resource: 'encounter_dcAdmission',
                icon: 'fa fa-plus-square',
                url: 'encounter_dcAdmission',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.dc_admission',
                resource: 'encounter_dcInitiateDischarge',
                icon: 'fa fa-plus-square',
                url: 'encounter_dcInitiateDischarge',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.dc_admission',
                resource: 'encounter_dcDischarged',
                icon: 'fa fa-plus-square',
                url: 'encounter_dcDischarged',
                auto_crud: true,
                showMenu: false
            }

        ]
    },
    {
        name: 'menu.bed_management',
        icon: 'fa fa-h-square',
        resource: "encounter_ipAdmission",
        url: 'bed-management',
        auto_crud: false,
    },
    {

        resource: 'op_billing_surgery_advice_master',
        icon: 'fa fa-user',
        url: 'op_billing_surgery_advice_master',
        check_permission: false,
        auto_crud: true,
        breadcrumb: 'Surgery Advice',
        showMenu: false
    },
    {
        name: 'menu.surgery_advice',
        resource: 'op_billing_surgery_advice',
        icon: 'fa fa-user',
        url: 'op_billing_surgery_advice',
        check_permission: false,
        auto_crud: true,
        breadcrumb: 'Surgery Advice',
        showMenu: false
    },
    {
        name: 'menu.surgery_package_advice',
        resource: 'op_billing_surgery_package_advice',
        icon: 'fa fa-user',
        url: 'op_billing_surgery_package_advice',
        check_permission: false,
        auto_crud: true,
        breadcrumb: 'Surgery Advice',
        showMenu: false
    },
    {

        resource: 'op_billing_package_advice_master',
        icon: 'fa fa-user',
        url: 'op_billing_package_advice_master',
        check_permission: false,
        auto_crud: true,
        breadcrumb: 'Surgery Advice',
        showMenu: false
    },
    {
        resource: 'op_billing_package_advice',
        icon: 'fa fa-user',
        url: 'op_billing_package_advice',
        check_permission: false,
        auto_crud: true,
        breadcrumb: 'Surgery Advice',
        showMenu: false
    },
    {
        name: 'menu.clearance_status',
        resource: "encounter_dischargeClearance",
        icon: 'fa fa-h-square',
        url: 'clearance_status',
        auto_crud: false,
        showMenu: true
    },
    {
        name: 'menu.clearance_status',
        resource: "encounter_packageMgmt",
        icon: 'fa fa-h-square',
        url: 'encounter_packageMgmt',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.counselling_detail',
        resource: "counselling_detail",
        icon: 'fa fa-h-square',
        url: 'counselling_detail',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        "name": "menu.follow_up_tabs",
        "resource": "generic_followup_tabs",
        "icon": "fa fa-user",
        "url": "generic_followup_tabs",
        "auto_crud": true,
        "check_permission": false,
        showMenu: true
    },
    {
        "name": "menu.financial_counselling_request_format",
        "resource": "financial_counselling_request_format",
        "icon": "fa fa-h-square",
        "url": "financial_counselling_request_format",
        "auto_crud": true,
        "check_permission": false,
        "showMenu": true
    },
    {
        name: 'menu.pending_request',
        resource: "pending_financial_counselling_requests",
        icon: 'fa fa-h-square',
        url: 'pending_financial_counselling_requests',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.counselling_confirm',
        resource: "counselling_confirm",
        icon: 'fa fa-h-square',
        url: 'counselling_confirm',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },


    {
        name: 'menu.counselling_follow_up',
        resource: "counselling_follow_up",
        icon: 'fa fa-h-square',
        url: 'counselling_follow_up',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.counselling_cancel',
        resource: "counselling_cancel",
        icon: 'fa fa-h-square',
        url: 'counselling_cancel',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.agora_call',
        icon: 'fa fa-h-square',
        url: 'agora_call',
        auto_crud: false,
        showMenu: false
    },

    {
        name: 'menu.counselling_service_item',
        resource: "counselling_service_item",
        icon: 'fa fa-h-square',
        url: 'counselling_service_item',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.counselling_surgery',
        resource: "counselling_surgery",
        icon: 'fa fa-h-square',
        url: 'counselling_surgery',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.counselling_ward',
        resource: "counselling_ward",
        icon: 'fa fa-h-square',
        url: 'counselling_ward',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.counselling_view_biometry_details',
        resource: "counselling_view_biometry_details",
        icon: 'fa fa-h-square',
        url: 'counselling_view_biometry_details',
        check_permission: false,
        auto_crud: true,
        showMenu: false
    },
     {
        name: 'menu.counselling_view_biometry_details_followup',
        resource: "counselling_view_biometry_details_followup",
        icon: 'fa fa-h-square',
        url: 'counselling_view_biometry_details_followup',
        check_permission: false,
        auto_crud: true,
        showMenu: false
    },
    {
        name: 'menu.counselling_surgery_component',
        resource: "counselling_surgery_component",
        icon: 'fa fa-h-square',
        url: 'counselling_surgery_component',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.counselling_format',
        resource: "counselling_format",
        icon: 'fa fa-h-square',
        url: 'counselling_format',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.counselling_follow_up_severity_master',
        resource: "counselling_follow_up_severity_master",
        icon: 'fa fa-h-square',
        url: 'counselling_follow_up_severity_master',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
     {
        name: 'menu.follow_up_severity_master',
        resource: "follow_up_severity_master",
        icon: 'fa fa-h-square',
        url: 'follow_up_severity_master',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.counselling_package',
        resource: "counselling_package",
        icon: 'fa fa-h-square',
        url: 'counselling_package',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.counselling_requested',
        resource: "counselling_requested",
        icon: 'fa fa-h-square',
        url: 'counselling_requested',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.counselling_discount',
        resource: "counselling_discount",
        icon: 'fa fa-h-square',
        url: 'counselling_discount',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.newBorn_vacination',
        resource: "newBorn_vacination",
        icon: 'fa fa-h-square',
        url: 'newBorn_vacination',
        check_permission: false,
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.update_MLC_details',
        resource: 'update_MLC_details',
        icon: 'fa fa-user',
        url: 'update_MLC_details',
        auto_crud: true,
        showMenu: false,
        breadcrumb: 'MLC Update'
    },
    {
        name: 'menu.update_MLC_details',
        resource: 'outside_admission_format',
        icon: 'fa fa-user',
        url: 'outside_admission_format',
        auto_crud: true,
        showMenu: false,
        breadcrumb: 'MLC Update'
      },
      {
        name: 'menu.encounter_virtual_admission',
        resource: 'encounter_virtual_admission',
        icon: 'fa fa-user',
        url: 'encounter_virtual_admission',
        auto_crud: true,
        showMenu: false,
        breadcrumb: 'MLC Update'
      },
      {
        name: 'menu.outside_hospital_transfer',
        resource: 'outside_hospital_transfer',
        icon: 'fa fa-user',
        url: 'outside_hospital_transfer',
        auto_crud: true,
        showMenu: false,
        breadcrumb: 'MLC Update'
      },
      {
        resource:"eligibility_request",
        url:"eligibility_request",
        auto_crud:true
      },
      {
        resource:"admission_preauth_request",
        url:"admission_preauth_request",
        auto_crud:true
    },
    {
        name: 'menu.nurse_transfer_approval',
        resource: 'transfer_requests',
        icon: 'fa fa-exchange',
        url: 'transfer_requests',
        auto_crud: true,
        check_permission: true,
        breadcrumb: 'Transfer Request'
    }
]